exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PersonButton__button___2Nu76 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border: 1px solid transparent;\n}\n.PersonButton__shadow___28U4l {\n  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.15);\n}\n.PersonButton__border___2Ue91 {\n  border: 1px solid #cdd8e3;\n}\n.PersonButton__name___OYe1L {\n  width: calc(100% - 50px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-transform: lowercase;\n  font-size: 0.9em;\n}\n.PersonButton__name___OYe1L p {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.PersonButton__box___1pz8e {\n  height: 50px;\n  width: 50px;\n  margin-top: -1px;\n  margin-bottom: -1px;\n  margin-left: -1px;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"button": "PersonButton__button___2Nu76",
	"shadow": "PersonButton__shadow___28U4l",
	"border": "PersonButton__border___2Ue91",
	"name": "PersonButton__name___OYe1L",
	"box": "PersonButton__box___1pz8e"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/person/PersonButton.styl
// module id = 235
// module chunks = 0